import React from 'react';
import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useScrollbarStyles } from 'modules/common';
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },

  nameHeader: {
    minWidth: theme.spacing(25),
    zIndex: '4',
    marginRight: theme.spacing(8)
  },
  nameHeaderDiv: {
    display: 'flex',
    justifyContent: 'space-between',
    color: theme.palette.text.secondary
  },
  otherHeader: {
    minWidth: theme.spacing(17),
    color: theme.palette.text.secondary,
    fontWeight: '600'
  },

  cell: {
    borderRight: '1px solid rgba(224, 224, 224, 1)'
  },
  dataCell: {
    fontSize: theme.spacing(3.75),
    padding: theme.spacing(0, 0.5)
  },
  sticky: {
    position: 'sticky',
    left: 0,
    background: 'white'
  },
  tableContainer: {
    maxHeight: theme.spacing(50)
  },
  nameCell: {
    zIndex: 2
  }
}));

type TeamTableLoadingProps = {
  columns: string[];
};

const TeamTableLoading: React.FC<TeamTableLoadingProps> = ({
  columns
}: TeamTableLoadingProps) => {
  const classes = useStyles();

  const classesScrollbar = useScrollbarStyles();

  return (
    <Paper
      className={classes.container}
      elevation={0}
      data-testid={'my-team-container-loading'}
    >
      <TableContainer
        className={classNames(
          classes.tableContainer,
          classesScrollbar.scrollbar
        )}
        data-testid={'my-team-table-container-loading'}
      >
        <Table
          aria-label="Team Table"
          stickyHeader
          size={'small'}
          data-testid={'my-team-table-loading'}
        >
          <TableHead data-testid={'my-team-table-header'}>
            <TableRow>
              <TableCell
                className={classNames(
                  classes.nameHeader,
                  classes.sticky,
                  classes.cell
                )}
                data-testid="team-table-column-name"
              >
                <div className={classes.nameHeaderDiv}>
                  <span>
                    <FormattedMessage id="insights.teamTable.nameColumn" />
                  </span>
                  <span>
                    <FormattedMessage id="insights.teamTable.total" />
                  </span>
                </div>
              </TableCell>

              {columns.slice(0, 8).map((i) => (
                <TableCell
                  className={classNames(classes.otherHeader, classes.cell)}
                  align="center"
                  key={i}
                  data-testid={`team-table-column-name-${i}`}
                >
                  {i}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody data-testid={'my-team-table-table-body'}>
            {[...new Array(5)].map((_, i) => (
              <TableRow key={`data_row-${i}`}>
                <TableCell
                  align="center"
                  className={classNames(
                    classes.cell,
                    classes.dataCell,
                    classes.sticky,
                    classes.nameCell
                  )}
                >
                  <Skeleton data-testid="table-cell-skeleton" />
                </TableCell>

                {columns.slice(0, 8).map((i) => (
                  <TableCell
                    align="center"
                    className={classNames(classes.cell, classes.dataCell)}
                    key={i}
                  >
                    <Skeleton data-testid="table-cell-skeleton" />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
export default TeamTableLoading;
